var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H56V53.98H8C3.58172 53.98 0 50.3983 0 45.98V8Z",
    fill: "#E91E62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.025 17.3966C30.0744 17.1653 30.2786 17 30.5151 17H49.8704C50.1471 17 50.3714 17.2243 50.3714 17.5011V19.7351C50.3714 20.0118 50.1471 20.2361 49.8704 20.2361H36.5212C35.9854 20.2361 35.8235 20.9638 36.3087 21.191L44.5269 25.0385C44.703 25.121 44.8155 25.2979 44.8155 25.4923L44.8155 26.7908C44.8155 27.1155 44.5114 27.3544 44.1959 27.2776L32.6928 24.4775C32.4246 24.4122 32.1542 24.576 32.0879 24.8439L30.7574 30.2178C30.6815 30.5246 30.344 30.6853 30.0579 30.5508L27.8388 29.5079C27.6281 29.4088 27.5134 29.1776 27.5619 28.9499L30.025 17.3966Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14188 17.6139C8.06931 17.2999 8.30778 17 8.63008 17L11.7552 17C11.9908 17 12.1945 17.164 12.2448 17.3941L14.8079 29.1244C14.9224 29.6484 15.669 29.6504 15.7863 29.127L18.4169 17.3915C18.4682 17.1626 18.6713 17 18.9058 17L23.1557 17C23.3891 17 23.5916 17.1611 23.644 17.3885L26.4506 29.5622C26.571 30.0844 27.3166 30.0786 27.4288 29.5545L30.0316 17.3962C30.0811 17.1651 30.2853 17 30.5216 17H33.3405C33.6651 17 33.9041 17.304 33.8273 17.6195L29.2104 36.5974C29.1557 36.8219 28.9546 36.98 28.7235 36.98H24.7562C24.5388 36.98 24.3463 36.8399 24.2794 36.6331L21.3757 27.6513C21.2271 27.1915 20.5778 27.1878 20.424 27.6459L17.4041 36.6384C17.3356 36.8425 17.1444 36.98 16.9291 36.98H13.0162C12.7829 36.98 12.5805 36.819 12.528 36.5918L8.14188 17.6139Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4f58ceae8c28ad05841c152bfbe3503b.svg";
export { ForwardRef as ReactComponent };